import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'Accueil', path: '/' },
  { label: 'À propos', path: '/a-propos' },
  { label: 'Contact', path: '/contact' },
  { label: 'Conditions générales', path: '/conditions-generales' },
  { label: 'Politique de confidentialité', path: '/politique-de-confidentialite' },
];

export default function Footer() {
  return (
    <footer className="bg-navy-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/f2ef5bfd-5866-433b-bac5-4405bb8fb383.png"
                alt="CICHORZ logo"
                className="h-9 w-auto object-contain"
              />
              <span className="font-heading font-bold text-xl tracking-wide">CICHORZ</span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-2">
              Mariusz Slawomir Cichorz
            </p>
            <p className="text-white/50 text-xs">SIRET : 102 737 178 00016</p>
            <p className="text-white/50 text-xs mt-1">Code APE : 62.01Z – Programmation informatique</p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-white/50 text-sm"></i>
                </div>
                <span className="text-white/70 text-sm leading-relaxed">
                  57 Rue Lecourbe<br />75015 Paris, France
                </span>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-phone-line text-white/50 text-sm"></i>
                </div>
                <a href="tel:+33758248029" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer">
                  +33 7 58 24 80 29
                </a>
              </li>
              <li className="flex items-center gap-3">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-white/50 text-sm"></i>
                </div>
                <a href="mailto:mariuszc1chorzz@outlook.com" className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer break-all">
                  mariuszc1chorzz@outlook.com
                </a>
              </li>
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-xs font-semibold uppercase tracking-widest text-white/40 mb-5">Navigation</h3>
            <ul className="space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-white/70 text-sm hover:text-white transition-colors cursor-pointer hover:translate-x-1 inline-block transition-transform duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} CICHORZ – Tous droits réservés
          </p>
          <div className="flex items-center gap-4">
            <Link to="/conditions-generales" className="text-white/40 text-xs hover:text-white/70 transition-colors cursor-pointer whitespace-nowrap">
              Conditions générales
            </Link>
            <span className="text-white/20">|</span>
            <Link to="/politique-de-confidentialite" className="text-white/40 text-xs hover:text-white/70 transition-colors cursor-pointer whitespace-nowrap">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
